var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.url)?_c('object',{attrs:{"id":"regro-preview-url","data":_vm.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }